export const analyticsEn = {
  analytics: {
    title: "Analytics",
    subtitle: "Comprehensive analysis of your farm performance",
    yieldPrediction: "Yield Prediction",
    historicalData: "Historical Data",
    trends: "Trends",
    comparison: "Comparison",
    export: "Export Report",
    dateRange: "Date Range",
    thisWeek: "This Week",
    thisMonth: "This Month",
    thisYear: "This Year",
    custom: "Custom",
    ndviTrend: "NDVI Trend",
    weatherImpact: "Weather Impact",
    cropPerformance: "Crop Performance",
    recommendations: "Recommendations"
  },
  analyticsUnified: {
    title: "Analytics & Reports",
    subtitle: "Comprehensive analysis, AI insights, and professional reports",
    tabBasic: "Basic Analytics",
    tabAI: "AI Insights",
    tabReports: "Reports Center"
  },
  analyticsPage: {
    title: "Basic Analytics",
    subtitle: "Essential parcel information and current monitoring metrics",
    farmerDashboard: "Farmer Dashboard",
    urbanManagerDashboard: "Urban Manager Dashboard",
    insurerDashboard: "Insurer Dashboard",
    generateNDVIHistory: "Generate NDVI History",
    runAnalyticsPipeline: "Run Analytics Pipeline",
    starting: "Starting...",
    generating: "Generating...",
    parcels: "Parcels",
    weather: "Weather",
    irrigation: "Irrigation",
    fertilizer: "Fertilizer",
    riskEur: "Risk €",
    harvestEur: "Harvest €",
    pac: "PAC",
    parcelOverview: "Parcel Overview & Statistics",
    selected: "Selected",
    parcelDescription: "Detailed parcel information and key metrics for agricultural analysis",
    locationDetails: "Location Details",
    coordinates: "Coordinates",
    area: "Area",
    hectares: "hectares",
    cropType: "Crop Type",
    notSpecified: "Not specified",
    agriculturalData: "Agricultural Data",
    plantingSeason: "Planting Season",
    expectedHarvest: "Expected Harvest",
    growingStage: "Growing Stage",
    keyMetrics: "Key Metrics",
    ndviHealthScore: "NDVI Health Score",
    lastData: "Last data",
    daysAgo: "days ago",
    noSatelliteData: "No satellite data",
    runPipeline: "Run pipeline",
    riskLevel: "Risk Level",
    unknown: "Unknown",
    insuranceStatus: "Insurance Status",
    environmentalConditions: "Environmental Conditions",
    noEnvironmentalData: "No environmental data available yet",
    runAnalyticsToCollect: "Run analytics to collect weather conditions",
    temperature: "Temperature",
    humidity: "Humidity",
    windSpeed: "Wind Speed",
    precipitation: "Precipitation",
    noRain: "No rain",
    rain: "Rain",
    recentRain: "Recent rain",
    noParcelSelected: "No parcel selected. Add a parcel first or select one from your parcels list.",
    currentEnvironmentalConditions: "Current Environmental Conditions",
    selectParcelToView: "Select a parcel to view current conditions",
    selectParcelIrrigation: "Select a parcel from the dropdown above to view irrigation recommendations",
    selectParcelNitrogen: "Select a parcel to view nitrogen optimization",
    errorLoadingAnalytics: "Error loading analytics",
    noAnalyticsAvailable: "No analytics available",
    runPipelineDesc: "Run the analytics pipeline to generate data for this parcel",
    pipelineStarted: "Process started",
    pipelineStartedDesc: "Data will appear in a few minutes. You can refresh the page.",
    errorGeneratingHistory: "Error generating history",
    couldNotComplete: "Could not complete",
    startingPipeline: "Starting analytics pipeline",
    generatingAnalytics: "Generating comprehensive analytics for",
    analyticsUpdated: "Analytics updated!",
    allMetricsGenerated: "All metrics generated successfully for",
    pipelineFailed: "Pipeline failed",
    couldNotGenerate: "Could not generate analytics",
    analysisComplete: "Analysis Complete",
    analysisError: "Analysis Error",
    failedToGenerate: "Failed to generate satellite data. Please try again.",
    analysisWarning: "Analysis Warning"
  }
};
